var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 29,
    viewBox: "0 0 10 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19462 0H2.00345C0.39176 0 -0.557947 1.80872 0.35697 3.13544L7.41154 13.3646C7.88297 14.0481 7.88297 14.9519 7.41154 15.6355L0.35697 25.8646C-0.557947 27.1913 0.39176 29 2.00345 29H9.19462V0Z",
    fill: "#D0E2FB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTail);
export default __webpack_public_path__ + "static/media/Tail.e6a5374d.svg";
export { ForwardRef as ReactComponent };